// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lite-compare-icon{display:flex;justify-content:center}.lite-compare-icon__image{position:relative;max-height:28px}.lite-compare-icon__image img{height:100%}.lite-compare-icon__image:hover .base-tooltip{display:block}", ""]);
// Exports
module.exports = exports;
